@if (details$ | async; as details) {
  <div class="grid gap-3 lg:grid-cols-2">
    <app-details-view label="Miniatura boxa">
      @if (isNotNil(details.logoUrl)) {
        <div class="w-32">
          <app-image-thumbnail
            [rounded]="false"
            size="full">
            <img
              [alt]="details.logoAlt || details.name"
              [fill]="true"
              [ngSrc]="details.logoUrl!"
              class="object-contain" />
          </app-image-thumbnail>
        </div>
      } @else {
        <app-image-thumbnail-unsupported />
      }
    </app-details-view>

    <app-details-view label="Nazwa">
      {{ details.name }}
    </app-details-view>

    <app-details-view label="Użytkownik">
      {{ details.ownerName }}
    </app-details-view>

    <app-details-view label="Zamówienie">
      {{ details.orderNumber }}
    </app-details-view>

    <app-details-view label="Status">
      <app-box-questionnaire-status [status]="details.status" />
    </app-details-view>

    <app-details-view label="Ankieta dostępna do">
      <app-box-questionnaire-availability
        [withLabel]="false"
        [createdAt]="details.createdAt"
        [endDate]="details.endDate"
        [status]="details.status" />
    </app-details-view>

    <app-details-view label="Czy wyświetlone">
      {{ details.isShown | boolean }}
    </app-details-view>

    <app-details-view label="Data dodania">
      <app-date-time [date]="details.createdAt" />
    </app-details-view>

    <div class="lg:col-span-2">
      <app-details-view label="Opis">
        @if (details.description) {
          <p class="whitespace-pre-line text-gray-700">
            {{ details.description }}
          </p>
        } @else {
          <app-no-data />
        }
      </app-details-view>
    </div>

    <div class="lg:col-span-2">
      <app-details-view label="Pytania ankiety">
        @if (isNotEmptyArray(details.questions)) {
          <div class="flex flex-col gap-8">
            @for (
              question of details.questions;
              track question.id;
              let index = $index
            ) {
              <section class="rounded-lg border border-gray-200 p-4">
                <h2
                  class="mb-5 font-medium tracking-[0.08em] text-[#232323] uppercase">
                  {{ questionLabel(question, index) }}
                </h2>

                <div class="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
                  @for (option of question.options; track option.id) {
                    <article
                      class="flex h-full flex-col border border-[#ece8e4] bg-white p-4 shadow-[0_0_0_1px_rgba(0,0,0,0.02)]">
                      <div class="relative aspect-square">
                        @if (option.imageUrl) {
                          <app-image-thumbnail
                            [rounded]="false"
                            size="full">
                            <img
                              [alt]="option.imageAlt || option.name"
                              [fill]="true"
                              [ngSrc]="option.imageUrl!"
                              class="object-contain" />
                          </app-image-thumbnail>
                        } @else {
                          <app-image-thumbnail-unsupported />
                        }
                      </div>

                      <div class="flex flex-1 flex-col pt-5">
                        @if (option.sourceName) {
                          <div class="font-semibold text-[#1b1b1b] uppercase">
                            {{ option.sourceName }}
                          </div>
                          <div class="pt-3 text-sm text-[#1b1b1b] uppercase">
                            {{ option.name }}
                          </div>
                        } @else {
                          <div class="font-semibold text-[#1b1b1b] uppercase">
                            {{ option.name }}
                          </div>
                        }

                        <div class="flex flex-1 flex-col">
                          <div class="text-xs font-bold text-[#1b1b1b]">
                            @for (
                              attribute of option.attributes;
                              track attribute.id
                            ) {
                              <div>{{ attribute.value }}</div>
                            }
                          </div>
                        </div>

                        @if (hasStateBadges(option)) {
                          <div class="mt-4 flex flex-wrap gap-2">
                            @if (option.isSelected) {
                              <app-badge variant="primary"> Wybrano </app-badge>
                            }

                            @if (option.isAutoSelected) {
                              <app-badge
                                appearance="soft"
                                variant="info">
                                Auto wybór
                              </app-badge>
                            }

                            @if (!option.isAvailable) {
                              <app-badge
                                appearance="outline"
                                variant="neutral">
                                Niedostępny
                              </app-badge>
                            }
                          </div>
                        }

                        @if (details.contextOperations.canBeSelectionChanged || hasDetails(option)) {
                          <div class="mt-5 pt-5 flex flex-col lg:flex-row gap-2 lg:justify-between lg:items-center border-t-1 border-gray-200">
                            @if (details.contextOperations.canBeSelectionChanged) {
                              <div>
                                <p-button
                                  (onClick)="changeOptionSelection(details.id, question.id, option.id)"
                                  [fluid]="true"
                                  [rounded]="true"
                                  [disabled]="option.isSelected"
                                  [label]="option.isSelected ? 'Wybrano' : 'Wybierz'"
                                  appPrimengButton
                                  severity="secondary"
                                  size="small"
                                  type="button" />
                              </div>
                            }

                            @if (hasDetails(option)) {
                              <div class="text-xs text-[#1b1b1b] lg:text-right">
                                Pozostało: {{ option.remainingQuantity }} / {{ option.availableQuantity }}
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </article>
                  }
                </div>
              </section>
            }
          </div>
        } @else {
          <app-no-data />
        }
      </app-details-view>
    </div>
  </div>
} @else {
  <app-spinner-filled />
}
